
<div class="hotel-info-wrapper overflow-x-hidden p-4" *ngIf="modalData as hotelInfo">

<div class="w-full flex justify-start items-center px-4 py-2 lg:p-0">
    <i class="ico-Close cursor-pointer text-xl ml-3" (click)="closeModal()"></i>
    <h3 class="text-lg" [innerHTML]="'درباره ' + hotelInfo?.Name"></h3>
</div>
<div class=" h-[88vh] overflow-y-auto lg:h-auto lg:overflow-visible">
    <div class="hotel-BriefDescription space-y-3 mt-4 text-justify " [innerHTML]="hotelInfo?.AboutHotel?.BriefDescription">
    </div>
    <div class="hotel-LocationDescription space-y-3 mt-6 text-justify font-bold" [innerHTML]="hotelInfo?.AboutHotel?.Description">
    </div>
    <div class="hidden md:block w-full h-px bg-gray-100 rounded-sm mt-6"></div>
    <section class="mt-6">
        <div *ngIf="hotelInfo?.HotelCafe">
        <div class="mt-4 text-xl text-black-500 font-bold">رستوران ها و کافی شاپ های {{modalData.Name}} </div>
        <section class="mt-4" *ngIf="hotelInfo?.HotelCafe?.Description">
            <div class="text-base font-bold">ساعت کاری و ظرفیت</div>
            <div class="hotel-resturants space-y-3 mt-2 text-justify" [innerHTML]="hotelInfo?.HotelCafe?.Description">
            </div>
        </section>
        <!-- <section class="mt-6">
            <div class="font-bold">
                درباره رستوران ها و تالار های {{hotelInfo.Name}} بیشتر بدانید
            </div>
            <div class="text-black-300 font-normal text-sm mt-2 leading-relaxed text-justify">
                رستوران هتل اسپیناس‌ پالاس سعادت ‌آباد، با نام لاتون واقع در طبقه دوم هتل، با دکوراسیونی مجلل و محیطی آرام نظر شما را جلب خواهدکرد. منوی بین ‌المللی این رستوران با سرو انواع غذاها، نوشیدنی‌ ها و دسرهای متنوع پذیرای حضور شما خواهد بود.رستوران دیبا با معماری منحصربفرد ایرانی و چیدمانی مدرن در طبقه همکف هتل، پذیرای حضور شما خواهد بود. منوی ایرانی این رستوران با سرو انواع غذاها و نوشیدنی‌ های اصیل ایرانی نظر شما را جلب خواهد کرد.کافه سان‌ ست واقع در طبقه لابی با دکوراسیونی منحصربفرد و محیطی آرام، با سرو انواع نوشیدنی ‌ها، میان‌ وعده‌ ها، پاستا، استیک، شیرینی‌ های تازه و... محل مناسبی برای یک دورهمی دوستانه و یا یک قرار ملاقات حرفه‌ای است. سالن ویژه استعمال سیگار نیز در این کافه قرار دارد.این هتل لوکس با داشتن 10 تالار بزرگ و اتاق جلسات مجهز، آمادگی پذیرایی از مهمانان و رویدادهای شما را در محیطی مجلل داراست. تالار گرند هال مجلل ‌ترین و باشکوه ‌ترین تالار در میان تالارهای متعدد این هتل لوکس است که قابلیت میزبانی از 2000 نفر را داراست. در کنار تالارهای بسیار لوکس این هتل، اتاق‌ های جلساتی قرار دارد که با انواع تجهیزات صوتی و تصویری مدرن قابلیت برگزاری جلسات تجاری، همایش‌ ها و رویدادهای مختلف را داراست. تالارهای چندمنظوره این هتل برای برگزاری رویدادهایی خاطره ‌انگیزی همانند جشن‌ازدواج، مطابق میل شما تجهیز شده و به همراه یک کادر حرفه‌ای و منویی گسترده از غذاها و نوشیدنی ‌های مختلف با دکوراسیونی شکوهمند در یکی از لوکس ‌ترین مناطق تهران پذیرای مهمانان شما خواهد بود. قیمت عروسی در هتل اسپیناس ‌پالاس سعادت ‌آباد بسته به سالن انتخابی و تعداد مهمانان متفاوت خواهد بود.
            </div>
        </section> -->
        <div class="hidden md:block w-full h-px bg-gray-100 rounded-sm mt-4"></div>
    </div>
        <section class="p-2 mt-2">
            <div class="text-black-500 bold text-xl font-bold">چند دلیل برای انتخاب {{hotelInfo.Name}}</div>
            <div class="w-full flex flex-col justify-center items-start">
            <div class="flex flex-col md:flex-row w-full mt-6">
                    <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                        <i class="text-2xl text-black-300 ico-Discount"></i>
                    </div>
                    <div class="w-12/12 md:w-11/12 md:-mr-10">
                        <h5 class="w-full text-black-500 text-base font-bold">ارائه کمترین قیمت</h5>
                        <div class="w-full text-sm leading-relaxed text-black-300">دریافت بهترین نرخ و صرفه جوئی در پرداخت وجه به جای پرداخت قیمت برد واحد اقامتی</div>
                    </div>
            </div>
            <div *ngIf="accommodation() !== 'ecolodge'" class="flex flex-col md:flex-row w-full mt-6">
                <div class="w-12/12 md:w-1/12 flex justify-start items-start">
                    <i class="text-2xl text-black-300 ico-DiscountCircle"></i>
                </div>
                <div class="w-12/12 md:w-11/12 md:-mr-10">
                    <div class="w-full text-black-500 text-base font-bold">صفر درصد کارمزد کنسلی</div>
                    <div class="w-full text-sm leading-relaxed text-black-300">در صورت لغو رزرو خود,شبکه ایران هتل هیچ گونه کارمزد کنسلی از شما دریافت نخواهد کرد.لازم به ذکر است این کارمزد ارتباطی با جریمه هتل ندارد</div>
                </div>
            </div>
        <div class="flex flex-col md:flex-row w-full mt-6">
            <div class="w-1/12 md:w-1/12 flex justify-start items-start">
                <i class="text-2xl text-black-300 ico-Message-line"></i>
            </div>
            <div class="w-12/12 md:w-11/12 md:-mr-10">
                <h5 class="w-full text-black-500 text-base font-bold">بررسی نظرات میهمانان</h5>
                <div class="w-full text-sm leading-relaxed text-black-300">ما نظرات مختلف میهمانانی که توسط ما در هتل اقامت داشته اند را بررسی نموده و این هتل را با رتبه کلی 4.5 از 5 به شما پیشنهاد می دهیم</div>
            </div>
    </div>
    <div *ngIf="hotelInfo?.ReasonToChoose" class="flex flex-col md:flex-row w-full mt-6">
        <div class="w-12/12 md:w-1/12 flex justify-start items-start">
            <i class="text-2xl text-black-300 ico-Questions"></i>
        </div>
        <div class="w-12/12 md:w-11/12 md:-mr-10">
            <div class="w-full text-black-500 text-base font-bold">دلایل ارائه شده هتل</div>
            <div class="w-full text-sm leading-relaxed text-black-300" [innerHtml]="hotelInfo?.ReasonToChoose?.ReasonToChoose"></div>
        </div>
    </div>
        </div>
        </section>
    </section>
</div>


</div>
